import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class BillingService {

    AUTH_API = `${environment.apiUrl}/auth/`;

    constructor(private http: HttpClient) {
    }
    async requestSession(): Promise<any> {
        const url = this.AUTH_API + 'stripe-session';
        return await this.http.post<any>(url, {}).toPromise();
    }
    async requestPortalUrl(): Promise<any> {
        const url = this.AUTH_API + 'portal-session';
        return await this.http.post<any>(url, {}).toPromise();
    }
}